import { getMatchPageUrl } from "../../../../utils/urls"
import * as ImageConstants from "../../../../constants/images"
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import PaginationFrontend from "@components/UI/PaginationFrontend"
import { LocalizedMatch } from "../../../../types/match"
import moment from "moment"
import Link from "next/link"
import { ColProps } from "react-bootstrap/Col"
import { Spin } from "antd"
import style from "./style.module.scss"
import Image from "next/image"

export function TurnMatches({
  matches,
  col,
  loading,
}: {
  matches: LocalizedMatch[]
  col?: ColProps
  loading?: boolean
}) {
  const isMobile = (typeof window !== "undefined" && window?.matchMedia("(max-width: 992px)")?.matches) || false

  const [matchesToDisplay, setMatchesToDisplay] = useState<LocalizedMatch[]>([])
  const [page, setPage] = useState<number>(1)

  useEffect(() => {
    if (isMobile && page) {
      setMatchesToDisplay(matches.slice(10 * (page - 1), 10 * page))
    } else {
      setMatchesToDisplay(matches)
    }
  }, [isMobile, matches, page])

  return (
    <Col className="turn-matches-cc" {...col}>
      <div className="container-div">
        <Spin spinning={loading}>
          <Row className={style.header}>
            <Col xs={4} lg={4} className={style.widgetHeaderTitle}>
              Data partita
            </Col>
            <Col xs={5} lg={5} className={style.widgetHeaderTitle}>
              Squadre
            </Col>
            <Col xs={3} lg={3} className={style.widgetHeaderTitle}>
              Risultato
            </Col>
          </Row>
          <Row className={style.container}>
            <Col>
              {matchesToDisplay.map((match, index) => {
                const isOdd = (index + 1) % 2 === 1

                const matchUrl = getMatchPageUrl(match.calciocomSlug!)

                return (
                  <Row key={match.id} className={style.matchRow + " " + (isOdd ? style.odd : style.even)}>
                    <Col xs={4} lg={4}>
                      <div className={style.date}>{match.date ? moment(match.date).format("DD.MM.YYYY") : "-"}</div>
                      <div className={style.hours}>{match.date ? moment(match.date).format("HH:mm") : "-"}</div>
                    </Col>
                    <Col xs={5} lg={5}>
                      <Link href={matchUrl} passHref>
                        <a className={style.teamContainer}>
                          <div className={style.teamImg}>
                            <Image
                              src={match.homeTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                              width={25}
                              height={25}
                              alt="homeTeam image"
                            />
                          </div>
                          <div className={style.teamName}>
                            <span>{match.homeTeam?.name}</span>
                          </div>
                        </a>
                      </Link>
                      <Link href={matchUrl} passHref>
                        <a className={style.teamContainer}>
                          <div className={style.teamImg}>
                            {match.awayTeam?.image?.path && (
                              <Image src={match.awayTeam?.image.path} width={25} height={25} alt="awayTeam image" />
                            )}
                          </div>
                          <div className={style.teamName}>
                            <span>{match.awayTeam?.name}</span>
                          </div>
                        </a>
                      </Link>
                    </Col>
                    <Col xs={3} lg={3} className={style.scoreContainer}>
                      <Link href={matchUrl} passHref>
                        <a>
                          {match.homeScore != null && match.awayScore != null ? (
                            <>
                              <div>{match.homeScore}</div>
                              <div> - </div>
                              <div>{match.awayScore}</div>
                            </>
                          ) : (
                            <div className={style.underline}>Statistiche</div>
                          )}
                        </a>
                      </Link>
                    </Col>
                  </Row>
                )
              })}
            </Col>
          </Row>
        </Spin>
      </div>
      <Row className={"pagination-row"}>
        <PaginationFrontend
          page={page}
          pageCount={Math.round(matches.length / 10)}
          onChange={(page) => {
            setPage(page)
          }}
        />
      </Row>
    </Col>
  )
}
